import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Icon } from '@sumtotal/react-foundation';
import styled from 'styled-components';

const MyGuideIconButton = styled(IconButton)`
  padding: 0.425rem 0.3rem;
  color: ${(props) => props.theme.variables.headerBarColor};
`;

const MyGuide = ({ myGuideMenu }) => {
  const onMyGuideClick = () => {
    window.GmCXt.openAppPanel();
  };
  return (
    <MyGuideIconButton
      size="small"
      color="inherit"
      label={myGuideMenu.name}
      disableRipple={false}
      disableFocusRipple={false}
      onClick={() => onMyGuideClick()}
    >
      <Icon iconType="IcomoonIcon" iconName="My Guide" size={1.75} />
    </MyGuideIconButton>
  );
};

// PropType check
MyGuide.propTypes = {
  /**
   * MyGuide SitemapNode
   */
  myGuideMenu: PropTypes.oneOfType([PropTypes.object])
};

MyGuide.defaultProps = {
  myGuideMenu: {}
};

export default MyGuide;
